import { render, staticRenderFns } from "./VireedProjectForm.vue?vue&type=template&id=27f9c218&"
import script from "./VireedProjectForm.vue?vue&type=script&lang=js&"
export * from "./VireedProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports